@if (isActive()) {
  {{ timeLeft().hours.toString().padStart(2, '0') }}:{{
    timeLeft().mins.toString().padStart(2, '0')
  }}:{{ timeLeft().secs.toString().padStart(2, '0') }}
}
